// extracted by mini-css-extract-plugin
module.exports = {"container":"container__MJP62","title":"title__2yFUo"};